import BasicLayout from 'components/atoms/Modal/Basic.Layout';
import { isACtiveIosVoice } from 'modules/actions/statusMenu';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getMobileCheck } from 'lib';

/* ios test */
import axios from 'axios';
const voiceApi = axios.create({});
/* ios test end */

const IosVoice = () => {
  const dispatch = useDispatch();

  window.AudioContext = window.AudioContext || window.webkitAudioContext;
  const audioContent = new AudioContext();
  let audioBuffer;
  let audioContext;
 
  const constentSet = () => {


    const startplay = async () => {
      const res = await voiceApi.post('/Voice', { tts: '안녕' }, { responseType: 'arraybuffer' });


      console.log(sessionStorage.getItem('ios_text'));

      console.log(res);
      console.log(res.data);
      console.log('##### 3' + audioContent.state);
      audioContext = audioContent;
      audioContext.createGain();
      console.log('##### 4' + audioContext.state);
      audioContext.resume();
      console.log('##### 5' + audioContext.state);
      audioContext.onstatechange = () => console.log(audioContext.state);
      console.log('222222');
      audioBuffer = await audioContext.decodeAudioData(res.data);
      playSound(audioBuffer);
    };
    function playSound(buffer) {
      console.log(buffer);
      const source = audioContext.createBufferSource();
      source.buffer = buffer;
      source.connect(audioContext.destination);
      source.start(0);
    }

    return (
      <>
        <div className="_ios_voice_div">
          <div className="_voice_title">
            <p>잠시기다려주시면 음성인식이 완료됩니다.</p>
          </div>
          <div className="_ios_voice_mic">
            <div className="_ios_voice_mic_area" onClick={() => startplay()}>
              <div className="_ios_icon" >
                <div className="spinner">
                  <div className="bounce1" />
                  <div className="bounce2" />
                  <div className="bounce3" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  return (
    <BasicLayout
      label=""
      value=""
      labelIcon=""
      viewStatus=""
      styleDef={{
        height: 'auto',
        background: 'linear-gradient(to left, rgb(1, 177, 203), rgb(37, 110, 239))',
        color: '#fff',
        borderRadius: '40px',
        width: '335px',
      }}
      onClickEvt={() => dispatch(isACtiveIosVoice())}
      error={null}
      contentSet={constentSet}
    />
  );
};

export default IosVoice;
